export default "__VITE_ASSET__79fc0759__"